import type { Job } from '@/types'

export type RecurrenceActionScope = 'current' | 'recurrence'

export function isRecurringJob(job: Pick<Job, 'recurrence_rule' | 'recurrence_parent' | 'recurrence_parent_info'> | null | undefined): boolean {
  if (!job) {
    return false
  }
  if (job.recurrence_parent_info) {
    return true
  }
  if (job.recurrence_parent != null && String(job.recurrence_parent).trim() !== '') {
    return true
  }
  const rule = String(job.recurrence_rule || 'none').trim().toLowerCase()
  return rule !== '' && rule !== 'none'
}

export function isCancelledWorkflowStatus(code?: string | null, label?: string | null): boolean {
  const normalizedCode = String(code || '').trim().toLowerCase()
  if (normalizedCode === 'cancelled' || normalizedCode === 'canceled' || normalizedCode.endsWith('_cancelled') || normalizedCode.endsWith('_canceled')) {
    return true
  }
  const normalizedLabel = String(label || '').trim().toLowerCase()
  return normalizedLabel === 'cancelled' || normalizedLabel === 'canceled' || normalizedLabel === 'cancel'
}
